import { InjectionToken } from '@angular/core';
import { FirebaseOptions, initializeApp } from 'firebase/app';
import { Auth, connectAuthEmulator, getAuth } from 'firebase/auth';

export const FIREBASE_OPTIONS = new InjectionToken<FirebaseOptions>('FIREBASE_OPTIONS');
export const FIREBASE_AUTH = new InjectionToken<Auth>('FIREBASE_AUTH');

export function createFirebaseAuth(options: FirebaseOptions, emulatorUrl: string | null): Auth {
  const auth = getAuth(initializeApp(options));
  if (emulatorUrl) connectAuthEmulator(auth, emulatorUrl, { disableWarnings: false });
  return auth;
}
